export default "__VITE_ASSET__CY5xLWku__"